import axios from 'axios'
import { validateBr } from 'js-brasil';
import { isvalidCNPJ } from './cnpj';
const { detect } = require('detect-browser');
const browserDetect = detect();


export async function getAsyncDadosConfig() {
    let ret = await axios.get('config.json')
    return ret
}


export function arrayMove(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length;
        while ((k--) + 1) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
}

export function removeValueFromArray(value, array) {
    var index = array.indexOf(value);
    while (index > -1) {
        array.splice(index, 1);
        index = array.indexOf(value);
    }
    return array;
}

export function removeElementFromArray(myObjects, prop, valu) {
    return myObjects.filter(function (val) {
        return val[prop] !== valu;
    });
}

export function returnObjectToArray(object) {
    let objArrayOriginal = []
    let objArrayFinal = []
    for (let key in object) {
        objArrayOriginal.push(Object.values(object[key]));
        objArrayFinal.push(Object.keys(object[key]))
    }
    return [objArrayFinal, objArrayOriginal]
}


export async function getConfig(param) {
    let config = await axios('config.json')
    let ret = config.data

    if (param) {
        ret = config.data[param]
        ret.service = ret.service ? ret.service : ""
        ret.baseUrl = ret && ret.server ? `${ret.protocol}://${ret.server}:${ret.port}${ret.service ? `/${ret.service}` : ''}` : ""
    }
    return ret
}


export async function getDadosConfig() {
    return await axios('config.json')
}

export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function contains(arr, valueOrObject) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].substring(0, valueOrObject.length) === valueOrObject) {
            return true;
        }
    }
    return false;
}

export function leftPad(value, totalWidth, paddingChar) {
    var length = totalWidth - value.toString().length + 1;
    return Array(length).join(paddingChar || '0') + value;
};

export function hasProfile(profiles, name) {
    if (Array.isArray(profiles)) {
        let profile = profiles.filter(function (item) { return item.name === name })
        if (profile.length > 0) return true;
    }
    return false;
}


export function invalidPagePermission(user) {

    if (!user) {
        return true
    }
    if (Array.isArray(user.profiles)) {
        let profile = user.profiles.filter(function (item) { return item.accessKey === 'editor-regras' })
        if (profile.length > 0)
            return false;
    }
     //console.log('nao localizado key');
    return true;
}

export function getUserToken(servico = 'corporate') {
    return sessionStorage.getItem("_nscorporate_user") ? JSON.parse(sessionStorage.getItem("_nscorporate_user")).tokens[servico] : ""
}

// obter o ip do cliente
export async function getIPs(callback) {

    var RTCPeerConnection = window.RTCPeerConnection
        || window.mozRTCPeerConnection
        || window.webkitRTCPeerConnection;

    var mediaConstraints = {
        optional: [{ RtpDataChannels: false }]
    };

    var servers = { iceServers: [{ urls: "stun:stun.l.google.com:19302" }] };
    var pc = new RTCPeerConnection(servers, mediaConstraints);

    pc.onicecandidate = (ice) => {
        if (ice.candidate) {
            var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
            var ips = []
            if (ip_regex.exec(ice.candidate.candidate) !== null) {
                ips.push(ip_regex.exec(ice.candidate.candidate)[0])
                callback(ips[ips.length - 1]);
            }
        }
    };
    pc.createDataChannel("");
    pc.createOffer(function (result) {
        pc.setLocalDescription(result, function () { }, function () { });
    }, function () { });
}

export function detectBrowser() {
    let browser = {}
    if (browserDetect) {
        browser.name = browserDetect.name
        browser.version = browserDetect.version
        browser.os = browserDetect.os
    }
    return browser
}

export function isValidCPF(cpf) {
    return validateBr.cpf(cpf);
};

export function isValidCNPJ(cnpj) {
    return isvalidCNPJ(cnpj);
};


